:host {
  .preview-record-modal {
    z-index: 1000000;
    position: fixed;
    max-width: 80%;
    min-width: 300px;
    width: auto;
    right: 50%;
    top: 50%;
    transform: translate(50%, -50%);
    max-height: 80vh;
    overflow-y: auto;
    padding: 60px 40px 40px;
    background-color: white;
    border: 0;
    border-radius: 10px;
    box-shadow:
      0 10px 20px rgba(0, 0, 0, 0.19),
      0 6px 6px rgba(0, 0, 0, 0.23);
    box-sizing: border-box;

    @media screen and (max-width: 768px) {
      width: 80%;
    }

    .preview {
      &__title {
        font-size: 18px;
        font-weight: 300;
        margin-bottom: 10px;
        top: 30px;
        position: absolute;
        color: #333;
        transform: translateY(-50%);

        @media screen and (max-width: 768px) {
          font-size: 14px;
        }
      }

      &__close {
        display: flex;
        position: absolute;
        top: 30px;
        transform: translateY(-50%);
        right: 20px;
        cursor: pointer;

        img {
          filter: invert(39%) sepia(0%) saturate(851%) hue-rotate(216deg) brightness(98%)
            contrast(85%);
          width: 18px;
        }
      }

      &__separator {
        height: 1px;
        background: #f5f5f5;
        width: 100%;
        position: absolute;
        top: 60px;
        left: 0;
      }

      &__media {
        margin-top: 20px;

        video,
        img {
          width: 100%;
          max-height: 500px;
        }
      }

      &__actions {
        margin-top: 40px;
        display: flex;
        justify-content: space-between;
      }
    }
  }
}
